
export const testimonialDataProd = [
  {
    user_details: {
      fullName: "Ronjon Nag",
      profilePicUrl: "https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FerWA7J0RzebLjC3nddYqMneVGd23%2Fronjon.webp?alt=media&token=6efc192f-750e-4df5-9927-3e5d1c1b0c7b",
      shortBio: "Ronjon Nag, developing AI for 40 years, co-founded and advised entities sold to Motorola, RIM/BlackBerry, and Apple. His firm R42 invests in AI and longevity. At Stanford Medicine, he teaches AI and longevity science. Awarded the IET Mountbatten Medal, the $1million Verizon Powerful Answers Award, the COGX AI Lifetime Achievement Award, he is a Silicon Valley Engineering Hall of Fame inductee. He is CEO of Agemica which is creating a vaccine for aging.",
      userName: "ronjon",
      user_id: "",
      is_creator: true,
    },
    title: "Founder R42, Inventor, Adjunct Prof. Stanford Medicine",
    content: "“Using Soopra AI, my students are able to talk to me even when I'm not there.”",
  },
  {
    user_details: {
      fullName: "Bill Harvey",
      profilePicUrl: "https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FVVHncaTBKDgoJWPPWPGd5coen4A2%2Fprofile_pic.jpeg?alt=media&token=48a92d6f-b0ce-44d3-b1db-814ae4607206",
      shortBio: "Media Researcher, Author, Entrepreneur, Inventor",
      userName: "bill",
      user_id: "",
      is_creator: true,
    },
    title: "Executive Chairman, Bill Harvey Consulting, Inc.",
    content: "“Having Experimented with many AIs, I'm delighted that Soopra is something I can trust to risk my reputation on.”",
  },
  {
    user_details: {
      fullName: "Adrian Cockcroft",
      profilePicUrl: "https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FrdgU62MBBlTIGMyO3CWK8fSl5qk1%2Fprofile_pic_adrian.png?alt=media&token=febde23f-c8e8-409e-9467-6c404be27be0",
      shortBio: "Adrian Cockcroft is a technologist and strategist with broad experience from the bits to the boardroom, in both enterprise and consumer-oriented businesses, from startups to some of the largest companies in the world, equally at home with hardware and software, development and operations. He’s best known as the cloud architect for Netflix during their trailblazing migration to AWS and was a very early practitioner and advocate of DevOps, microservices, and chaos engineering, helping bring these concepts to the wider audience they have today. Adrian spent the last few years as a VP at Amazon deeply immersed in the dual challenges of helping Amazon itself – one of the largest companies in the world – become more sustainable, and via AWS – one of the largest technology suppliers in the world – helping its enterprise and public sector customers become more sustainable.",
      userName: "Cockcroft",
      user_id: "",
      is_creator: true,
    },
    title: "Cloud architect for Netflix during their migration to AWS",
    content: "“My Soopra AI persona writes better than I do. It drafts my blog posts, answers my interview questions and sounds exactly like me. I just review and hit publish. It’s like outsourcing my brain... but smarter.”",
  },
  {
    user_details: {
      fullName: "Frank Sortino",
      profilePicUrl: "https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FEdPwrOi2oyXchOxXldvc8jY1FBm2%2Fprofile_pic.jpg?alt=media&token=822c8d4a-565e-4a89-bf8f-5e5630385cf5",
      shortBio: "Welcome, I am professor Emeritus in Finance and director of the Pension Research Institute. This AI Generative Chatbot was developed for classes I taught with Dr. Ronjon Nag at Stanford University. We each had to condense a lifetime of learning and experience into 5 hours of education.",
      userName: "sortino-chat",
      user_id: "",
      is_creator: true,
    },
    title: "Professor Emeritus in Finance and Director of the Pension Research Institute",
    content: "“Sometimes students think their questions are embarrassing, so asking my AI is an easy way for them to get the answers they want.”",
  },
  {
    user_details: {
      fullName: "Chuck Young",
      profilePicUrl: "https://firebasestorage.googleapis.com/v0/b/mimio---db.appspot.com/o/images%2FjGpGqtsnR6YyRPDRUMiwMqckg0k1%2FIMG_3671.jpg?alt=media&token=31d33f23-025f-4935-bcca-b6db20ff0f48",
      shortBio: "Inventor, Founder CEO, Communications Researcher",
      userName: "chuck",
      user_id: "",
      is_creator: true,
    },
    title: "CEO, Ameritest Global Research",
    content: "“Surprisingly easy to train your Soopra, using conversational onboarding.”",
  },
]
